// Third party
import React from 'react';

// Components
import ComparisonTopBarBaseMenuItem from './ComparisonTopBarBaseMenuItem';

// Utils
import { FormattedMessage } from '../../../../../utils/i18n';

// Types
import QuestionnaireAnswers from '@/types/questionnaire-answers';

type Props = {
  onClick: () => void;
};

const ComparisonTopBarRationaleMenuItem = ({ onClick }: Props) => (
  <ComparisonTopBarBaseMenuItem onClick={onClick} label={<FormattedMessage id="Comparison.Questionnaire.Rationale.IconTitle" />} />
);

export default ComparisonTopBarRationaleMenuItem;
